/* eslint-disable @typescript-eslint/naming-convention */

import {
  createScreenViewedEvent,
  createComponentClickedEvent,
  track,
} from "./base"

export const rewardsViewed = ({
  currentTab,
  pointBalance,
}: {
  currentTab: "rewards" | "earning points"
  pointBalance?: number
}) => {
  track(
    createScreenViewedEvent({
      current_screen: "Rewards",
      current_tab: currentTab,
      viewed_values: {
        point_balance: pointBalance,
      },
    })
  )
}

export const referAFriendClicked = ({
  currentTab,
  pointBalance,
}: {
  currentTab: "rewards" | "earning points"
  pointBalance?: number
}) => {
  track(
    createComponentClickedEvent({
      current_screen: "Rewards",
      component_type: "button",
      component_function: "refer a friend",
      component_text: "Refer a Friend",
      clicked_values: {
        point_balance: pointBalance,
        current_tab: currentTab,
      },
    })
  )
}
